export { Routes as PrivateRoutes } from './Routes';
